
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gray-50">
      <div className="absolute inset-0 w-full h-full">
        <iframe
          src="https://www.youtube.com/embed/LXHHMGQdzh0?autoplay=1&mute=1&loop=1&playlist=LXHHMGQdzh0&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&disablekb=1&iv_load_policy=3"
          title="Atelier Folio KV"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.78vh] min-w-full min-h-full aspect-video border-0 pointer-events-none"
          allow="autoplay; encrypted-media"
          allowFullScreen
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60 z-[1]"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto w-full text-center px-6">
        <h1
          className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight tracking-tight"
          style={{
            fontFamily: 'Playfair Display, serif',
            textShadow: '0 2px 20px rgba(0,0,0,0.5), 0 1px 6px rgba(0,0,0,0.3)',
          }}
        >
          まるで、持ち運べるアトリエ
        </h1>
        <p
          className="text-xl md:text-2xl text-white mb-4 font-medium tracking-wide"
          style={{ textShadow: '0 1px 12px rgba(0,0,0,0.5), 0 1px 4px rgba(0,0,0,0.3)' }}
        >
          線を変える、モバイルiPadケース
        </p>
        <p
          className="text-base md:text-lg text-white/85 mb-16 tracking-wide font-light"
          style={{ textShadow: '0 1px 8px rgba(0,0,0,0.4)' }}
        >
          描く、見る、調べる、観る。すべての創作行為に、最適な角度を持ち運ぶ。
        </p>

        <a
          href="#cta"
          className="group relative inline-flex flex-col items-center gap-3 cursor-pointer"
        >
          <span className="inline-flex items-center gap-1.5 px-5 py-1.5 bg-white text-red-600 text-sm font-bold rounded-full shadow-lg animate-[badgeBounce_2s_ease-in-out_infinite]">
            <i className="ri-fire-fill text-base text-red-500"></i>
            早割最大25%Off
          </span>
          <span className="relative inline-flex items-center gap-3 px-14 py-5 bg-[#C8956C] text-white text-lg font-bold rounded-full hover:bg-[#B8845C] transition-all duration-300 hover:scale-105 whitespace-nowrap shadow-[0_0_30px_rgba(200,149,108,0.4)] hover:shadow-[0_0_50px_rgba(200,149,108,0.6)]">
            <span className="absolute inset-0 rounded-full bg-[#C8956C] animate-ping opacity-15"></span>
            <span className="relative flex items-center gap-3">
              Makuake優先案内を受け取る
              <span className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full group-hover:bg-white/30 transition-colors">
                <i className="ri-arrow-right-line text-lg"></i>
              </span>
            </span>
          </span>
        </a>
      </div>

      {/* スクロールダウン誘導 */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-3">
        <p className="text-xs tracking-[0.25em] text-white/50 uppercase">Scroll</p>
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex justify-center pt-2 relative">
          <div className="w-1 h-2.5 bg-white/70 rounded-full animate-[scrollDot_1.8s_ease-in-out_infinite]"></div>
        </div>
        <div className="flex flex-col items-center gap-1 animate-[fadeUpDown_2s_ease-in-out_infinite]">
          <i className="ri-arrow-down-s-line text-white/40 text-sm"></i>
          <i className="ri-arrow-down-s-line text-white/25 text-sm -mt-2"></i>
        </div>
      </div>

      <style>{`
        @keyframes scrollDot {
          0% { opacity: 1; transform: translateY(0); }
          50% { opacity: 0.3; transform: translateY(10px); }
          100% { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeUpDown {
          0%, 100% { opacity: 0.4; transform: translateY(0); }
          50% { opacity: 0.8; transform: translateY(4px); }
        }
        @keyframes badgeBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-4px); }
        }
      `}</style>
    </section>
  );
}
